import React from "react";
import { Typography, Button } from 'antd';
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { DownloadOutlined } from "@ant-design/icons";
import axios from "../api/axios";
import { useNavigate } from "react-router-dom";
const MCQ = ({
    MCQsItems,
    topic,
}) => {
    const { Title } = Typography
    const navigate = useNavigate();
    // console.log(MCQsItems, "MCQ")
    const generateLatexAndDownload = () => {
        let texStr = "";
        MCQsItems.map((dataEl, dataIndex) => {
            texStr = texStr + `${dataIndex + 1}.  `;
            texStr = texStr + `${dataEl.story}\n`;
            texStr = texStr + `${dataEl.question}\n\n`;
            dataEl.alternativeOptions.map((el, MCQIndex) => {
                texStr =
                    texStr +
                    `${String.fromCharCode("a".charCodeAt(0) + MCQIndex)}. ${el}\n\n`;
                return null;
            });
            texStr = texStr + `\n\n`;
            return null;
        });

        ////console.log("texStr iterate", texStr);
        downloadMcqFile(texStr);
    };
    const downloadMcqFile = (str) => {
        const hiddenElement = document.createElement("a");
        hiddenElement.href = "data:text/plain;charset=utf-8," + encodeURI(str);
        hiddenElement.target = "_blank";
        hiddenElement.download = `MCQs.txt`;
        hiddenElement.click();
    }
    function SaveData() {
        let data;
        let arr = [];
        console.log(MCQsItems, 'mcqitems')
        for (let i = 0; i < MCQsItems?.length; i++) {
            let options = [];
            let questionCategories = [];
            for (let j = 0; j < MCQsItems[i]?.alternativeOptions?.length; j++) {
                options.push(MCQsItems[i]?.alternativeOptions[j]);
            }
            questionCategories.push(MCQsItems[i]?.category);
            data = {
                story: MCQsItems[i]?.story,
                mcqCategory: topic,
                question: MCQsItems[i]?.question,
                options: options,
                questionCategory: MCQsItems[i]?.category,
            };
            arr.push(data);
        }
        axios
            .post("send_mcq_data/", arr, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${window.localStorage.getItem("access")}`,
                },
                withCredentials: true,
            })
            .then((res) => {
                alert("Data has been saved in Database successfully!");
            })
            .catch((err) => {
                alert("Server Error!");
                if (err?.response?.status === 401) {
                    console.log(err);
                    window.localStorage.setItem("isLoggedIn", "false");
                    navigate("/login");
                }
            });
        console.log(arr, 'arr')
    }
    return (
        <>
            {MCQsItems &&
                <>
                    <Title level={3} className="mb-3">
                        Quesions Preview ({MCQsItems?.length} Questions)
                    </Title>
                    {
                        MCQsItems?.map((item, itemIndex) => {
                            return (
                                <ul className="ul" key={itemIndex} style={{ color: "black" }}>
                                    <TransitionGroup
                                        component={null}
                                        appear={true}
                                        in={true}
                                        mountOnEnter={true}
                                        unmountOnExit={true}
                                    >
                                        <CSSTransition timeout={500} classNames="exampe">
                                            <li>
                                                <Title level={4} className="mb-4">
                                                    <span
                                                        dangerouslySetInnerHTML={{
                                                            __html: `${itemIndex + 1}. `,
                                                        }}
                                                    ></span>
                                                    <span
                                                        dangerouslySetInnerHTML={{
                                                            __html: item?.story
                                                            ,
                                                        }}
                                                    ></span>
                                                </Title>

                                                <Title level={4} className="mb-2" >
                                                    {item?.question}
                                                </Title>
                                                <ul className="ul-2" style={{ color: "black" }}>
                                                    {item?.alternativeOptions.map((el, optionIndex) => {
                                                        return (
                                                            <li key={optionIndex}>
                                                                <b>
                                                                    {String.fromCharCode(
                                                                        "a".charCodeAt(0) + optionIndex
                                                                    )}.
                                                                </b>
                                                                &nbsp;&nbsp;{el}
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                                <br />
                                            </li>
                                        </CSSTransition>
                                    </TransitionGroup>
                                </ul>
                            );
                        })
                    }
                    <div className="d-lg-flex d-md-flex justify-content-between">
                        <Button
                            size="large"
                            icon={<DownloadOutlined />}
                            onClick={generateLatexAndDownload}
                            // style={{ paddingLeft: "4rem" }}
                            className="d-lg-flex  d-none align-items-center d-mcq py-lg-0 py-md-0 py-4 col-xl-5 col-lg-6 col-md-7 bank generate justify-content-center"
                        >
                            Download Generated MCQs as a Text File  ({MCQsItems?.length} Questions)
                        </Button>
                        <Button
                            size="large"
                            icon={<DownloadOutlined />}
                            onClick={generateLatexAndDownload}
                            // style={{ paddingLeft: "4rem" }}
                            className="d-lg-none  d-flex align-items-center d-mcq py-lg-0 py-md-0 py-4 col-xl-5 col-lg-6 col-md-7 bank generate justify-content-center"
                        >
                            Download MCQs as a Text File  ({MCQsItems?.length} Questions)
                        </Button>
                        <Button
                            size="large"
                            icon={<DownloadOutlined />}
                            onClick={SaveData}
                            className="d-flex align-items-center justify-content-center ms-lg-0 ms-md-2 mt-lg-0 mt-md-0 mt-2 col-xl-3 col-lg-4 col-md-5 bank generate"
                            style={{ whiteSpace: "nowrap" }}
                        >
                            Save MCQs to Question Bank
                        </Button>
                    </div>
                </>
            }
        </>
    )
}
export default MCQ;